// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  DatePicker,
  Form,
  Grid,
  Image,
  Input,
  Message,
  Modal,
  Popconfirm,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  Tag,
  Upload
} from '@arco-design/web-react';
import dayjs from 'dayjs';

import { get, post } from '../requestNew';
import { API_CONFIG } from '../utils';
import './index.scss';

const FormItem = Form.Item;
const Option = Select.Option;
const Row = Grid.Row;
const Col = Grid.Col;
const RangePicker = DatePicker.RangePicker;
const URL_UPLOAD = API_CONFIG.uploadUrl;
const VIDEO_TRANSCODE_STATUS_URL = API_CONFIG.videoTranscodeStatusUrl;
const UPLOAD_BIZ_DOMAIN = 'member';
const UPLOAD_DATA = { bizDomain: UPLOAD_BIZ_DOMAIN };
const VIDEO_UPLOAD_DATA = { bizDomain: UPLOAD_BIZ_DOMAIN };

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 14
  }
};

/** 弹窗内并排两列时，标签略宽于默认 formItemLayout */
const formItemRowTwinLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
};

const contentTypeOptions = [
  // { label: '每日复盘', value: 1, color: 'arcoblue' },
  { label: '高手连线', value: 2, color: 'green' },
  { label: '模式拆解', value: 3, color: 'purple' }
];

const sortTypeOptions = [
  { label: '最新', value: 'newest' },
  { label: '最热', value: 'hot' }
];

/** 全部 / 是 / 否，用于列表筛选 */
const triStateYesNoOptions = [
  { label: '全部', value: '' },
  { label: '是', value: '1' },
  { label: '否', value: '0' }
];

const getContentTypeMeta = (value?: number) => {
  return contentTypeOptions.find(item => item.value === value) || null;
};

/** 上传列表项预览地址（与 Arco picture-card 内部逻辑一致） */
const getUploadItemPreviewUrl = (file: any) => {
  if (!file) return '';
  if (file.url) return file.url;
  if (file.response?.data) return file.response.data;
  if (file.originFile && typeof URL !== 'undefined' && URL.createObjectURL) {
    return URL.createObjectURL(file.originFile);
  }
  return '';
};

function MemberContentManagement() {
  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<any[]>([]);
  const [coverFileList, setCoverFileList] = useState<any[]>([]);
  const [videoFileList, setVideoFileList] = useState<any[]>([]);
  const [mindMapFileList, setMindMapFileList] = useState<any[]>([]);
  // const [aiInterpretationFileList, setAiInterpretationFileList] = useState<any[]>([]);
  const [videoPreviewVisible, setVideoPreviewVisible] = useState(false);
  const [videoPreviewUrl, setVideoPreviewUrl] = useState('');
  const [videoUploading, setVideoUploading] = useState(false);
  const formRef = useRef<any>({});

  const toDateTimeText = (value?: string) => {
    if (!value) return '-';
    const parsed = dayjs(value);
    if (!parsed.isValid()) return '-';
    return parsed.format('YYYY-MM-DD HH:mm:ss');
  };

  /** 校验视频是否已完成转码；未完成时给出统一提示 */
  const checkVideoTranscodeStatus = async (videoUrl?: string) => {
    if (!videoUrl) {
      Message.error('视频地址不存在');
      return false;
    }
    try {
      const res = await get(VIDEO_TRANSCODE_STATUS_URL, { url: videoUrl });
      const success = res?.data === true || res?.data === 'true' || res === true;
      if (!success) {
        Message.warning('视频转码中，请稍后再试');
      }
      return success;
    } catch (error) {
      Message.error('转码状态校验失败');
      return false;
    }
  };

  const getList = (reset?: boolean) => {
    setLoading(true);
    const searchValues = formSearch.getFieldsValue();
    const productionTimeRange = searchValues.productionTimeRange || [];
    const nextPageNum = reset ? 1 : pageNum;
    const nextPageSize = reset ? 20 : pageSize;

    if (reset) {
      setPageNum(1);
      setPageSize(20);
    }

    const params: any = {
      pageNum: nextPageNum,
      pageSize: nextPageSize
    };

    if (productionTimeRange.length === 2) {
      params.productionDateStart = dayjs(productionTimeRange[0]).format('YYYY-MM-DD');
      params.productionDateEnd = dayjs(productionTimeRange[1]).format('YYYY-MM-DD');
    }
    if (searchValues.title) {
      params.title = searchValues.title.trim();
    }
    if (searchValues.sortType) {
      params.sortType = searchValues.sortType;
    }
    if (searchValues.deleteStatus === '1') {
      params.isValid = false;
    } else if (searchValues.deleteStatus === '0') {
      params.isValid = true;
    }
    if (searchValues.isTopFilter === '1') {
      params.isTop = 1;
    } else if (searchValues.isTopFilter === '0') {
      params.isTop = 0;
    }
    if (searchValues.isOnShelfFilter === '1') {
      params.isOnShelf = 1;
    } else if (searchValues.isOnShelfFilter === '0') {
      params.isOnShelf = 0;
    }
    if (searchValues.isMemberContentFilter === '1') {
      params.isMemberContent = 1;
    } else if (searchValues.isMemberContentFilter === '0') {
      params.isMemberContent = 0;
    }

    get('/sys/umsMemberContent/page', params)
      .then((res: any) => {
        const { data } = res || {};
        const { list, total: totalCount } = data || {};
        setDataList(list || []);
        setTotal(totalCount || 0);
      })
      .catch(() => {
        Message.error('获取列表失败');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetSearch = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(20);
    getList(true);
  };

  const add = () => {
    formRef.current = {};
    form.resetFields();
    setCoverFileList([]);
    setVideoFileList([]);
    setMindMapFileList([]);
    // setAiInterpretationFileList([]);
    form.setFieldsValue({
      videoUrl: '',
      isTop: false,
      isOnShelf: false,
      isMemberContent: true,
      productionTime: undefined
    });
    setVisible(true);
  };

  const edit = (record: any) => {
    formRef.current = record;
    form.resetFields();
    setCoverFileList(record.coverUrl ? [{ uid: 'cover-init', url: record.coverUrl, name: 'cover' }] : []);
    setVideoFileList(record.videoUrl ? [{ uid: 'video-init', url: record.videoUrl, name: 'video' }] : []);
    setMindMapFileList(record.mindMapUrl ? [{ uid: 'mind-init', url: record.mindMapUrl, name: 'mindMap' }] : []);
    // setAiInterpretationFileList(
    //   record.aiInterpretationUrl ? [{ uid: 'ai-init', url: record.aiInterpretationUrl, name: 'ai' }] : []
    // );
    form.setFieldsValue({
      ...record,
      videoUrl: record.videoUrl || '',
      contentDesc: record.contentDesc || record.desc || '',
      isTop: record.isTop === 1,
      isOnShelf: record.isOnShelf === 1,
      isMemberContent: record.isMemberContent === 1,
      productionTime: record.productionTime ? dayjs(record.productionTime) : undefined
    });
    setVisible(true);
  };

  const editCancel = () => {
    if (videoUploading) {
      Message.warning('视频上传中，请等待上传完成后再关闭');
      return;
    }
    formRef.current = {};
    form.resetFields();
    setCoverFileList([]);
    setVideoFileList([]);
    setMindMapFileList([]);
    // setAiInterpretationFileList([]);
    setVideoUploading(false);
    setVisible(false);
  };

  const onOk = async () => {
    if (videoUploading) {
      Message.warning('视频上传中，请等待上传完成后再提交');
      return;
    }
    try {
      const values = await form.validate();
      setLoading(true);
      const payload: any = {
        ...values,
        id: formRef.current.id,
        isTop: values.isTop ? 1 : 0,
        isOnShelf: values.isOnShelf ? 1 : 0,
        isMemberContent: values.isMemberContent ? 1 : 0,
        productionTime: values.productionTime
          ? dayjs(values.productionTime).format('YYYY-MM-DD HH:mm:ss')
          : undefined
      };

      const url = formRef.current.id ? '/sys/umsMemberContent/update' : '/sys/umsMemberContent/add';
      const actionText = formRef.current.id ? '编辑' : '新增';
      const res = await post(url, payload);

      if (res?.code === 200) {
        Message.success(`${actionText}成功`);
        editCancel();
        getList();
      }
    } catch (error) {
      if (error?.errorFields) {
        Message.error('请完善表单信息');
      }
    } finally {
      setLoading(false);
    }
  };

  const del = (record: any) => {
    if (!record?.id) {
      Message.error('记录ID不存在');
      return;
    }
    setLoading(true);
    post(`/sys/umsMemberContent/delete?id=${record.id}`)
      .then((res: any) => {
        if (res?.code === 200) {
          Message.success('删除成功');
          getList();
        }
      })
      .catch(() => {
        Message.error('删除失败');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateSwitchField = async (
    record: any,
    field: 'isTop' | 'isOnShelf' | 'isMemberContent' | 'isValid',
    value: 0 | 1
  ) => {
    if (!record?.id) {
      Message.error('记录ID不存在');
      return;
    }
    if (field === 'isOnShelf' && value === 1) {
      const pass = await checkVideoTranscodeStatus(record?.videoUrl);
      if (!pass) return;
    }
    const payload: any = {
      id: record.id,
      [field]: value
    };
    setLoading(true);
    post('/sys/umsMemberContent/update', payload)
      .then((res: any) => {
        if (res?.code === 200) {
          Message.success('更新成功');
          getList();
        }
      })
      .catch(() => {
        Message.error('更新失败');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getUploadUrl = (file: any) => file?.url || file?.response?.data || '';

  const handleCoverChange = (fileList: any[]) => {
    const latest = fileList.slice(-1);
    const latestUrl = getUploadUrl(latest[0]);
    setCoverFileList(latest);
    form.setFieldValue('coverUrl', latestUrl || '');
    if (latestUrl) {
      Message.success('上传成功');
    }
  };

  const handleVideoChange = (fileList: any[]) => {
    const latest = fileList.slice(-1);
    const latestFile = latest[0];
    const latestUrl = getUploadUrl(latestFile);
    setVideoUploading(latestFile?.status === 'uploading');
    setVideoFileList(latest);
    form.setFieldValue('videoUrl', latestUrl || '');
    if (latestUrl) {
      Message.success('上传成功，视频转码耗时5-10分钟，请转码成功后再上架视频');
    }
  };

  const handleMindMapChange = (fileList: any[]) => {
    const latest = fileList.slice(-1);
    const latestUrl = getUploadUrl(latest[0]);
    setMindMapFileList(latest);
    form.setFieldValue('mindMapUrl', latestUrl || '');
    if (latestUrl) {
      Message.success('上传成功');
    }
  };

  // const handleAiInterpretationChange = (fileList: any[]) => {
  //   const latest = fileList.slice(-1);
  //   const latestUrl = getUploadUrl(latest[0]);
  //   setAiInterpretationFileList(latest);
  //   form.setFieldValue('aiInterpretationUrl', latestUrl || '');
  //   if (latestUrl) {
  //     Message.success('上传成功');
  //   }
  // };

  const columns: TableColumnProps[] = [
    {
      title: '序号',
      width: 60,
      render: (_, __, index) => (pageNum - 1) * pageSize + index + 1
    },
    {
      title: '封面',
      dataIndex: 'coverUrl',
      width: 90,
      render: value =>
        value ? <Image src={value} width={48} height={48} fit="cover" preview={true} style={{ borderRadius: 4 }} /> : '-'
    },
    {
      title: '视频',
      dataIndex: 'videoUrl',
      width: 100,
      render: (value, record) =>
        value ? (
          <Tag
            color="arcoblue"
            size="large"
            style={{ cursor: record?.isValid === 0 ? 'not-allowed' : 'pointer', opacity: record?.isValid === 0 ? 0.5 : 1 }}
            onClick={async () => {
              if (record?.isValid === 0) return;
              const pass = await checkVideoTranscodeStatus(value);
              if (!pass) return;
              setVideoPreviewUrl(value);
              setVideoPreviewVisible(true);
            }}
          >
            预览
          </Tag>
        ) : (
          '-'
        )
    },
    {
      title: '标题',
      dataIndex: 'title',
      width: 180,
      ellipsis: true
    },
    {
      title: '简介',
      dataIndex: 'contentDesc',
      width: 220,
      ellipsis: true,
      render: (_, record) => record.contentDesc || record.desc || '-'
    },
    {
      title: '类型',
      dataIndex: 'contentType',
      width: 100,
      render: value => {
        const meta = getContentTypeMeta(value);
        return meta ? <Tag color={meta.color}>{meta.label}</Tag> : '-';
      }
    },
    {
      title: '主讲人',
      dataIndex: 'teacher',
      width: 120
    },
    {
      title: '学习人数',
      dataIndex: 'studyCount',
      width: 100,
      render: value => value ?? 0
    },
    {
      title: '思维导读',
      dataIndex: 'mindMapUrl',
      width: 90,
      render: value =>
        value ? (
          <Image src={value} width={48} height={48} fit="cover" preview={true} style={{ borderRadius: 4 }} />
        ) : (
          '-'
        )
    },
    // {
    //   title: 'AI解读',
    //   dataIndex: 'aiInterpretationUrl',
    //   width: 90,
    //   render: value =>
    //     value ? (
    //       <Image src={value} width={48} height={48} fit="cover" preview={true} style={{ borderRadius: 4 }} />
    //     ) : (
    //       '-'
    //     )
    // },
    {
      title: '内容制作时间',
      dataIndex: 'productionTime',
      width: 160,
      render: value => toDateTimeText(value)
    },
    {
      title: '上传时间',
      dataIndex: 'createTime',
      width: 160,
      render: value => toDateTimeText(value)
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      width: 160,
      render: value => toDateTimeText(value)
    },
    {
      title: '是否上架',
      dataIndex: 'isOnShelf',
      width: 100,
      render: (value, record) => (
        <Switch
          checked={value === 1}
          disabled={record?.isValid === 0}
          onChange={checked => updateSwitchField(record, 'isOnShelf', checked ? 1 : 0)}
        />
      )
    },
    {
      title: '会员专属',
      dataIndex: 'isMemberContent',
      width: 120,
      render: (value, record) => (
        <Switch
          checked={value === 1}
          disabled={record?.isValid === 0}
          onChange={checked => updateSwitchField(record, 'isMemberContent', checked ? 1 : 0)}
        />
      )
    },
    {
      title: '是否置顶',
      dataIndex: 'isTop',
      width: 100,
      render: (value, record) => (
        <Switch
          checked={value === 1}
          disabled={record?.isValid === 0}
          onChange={checked => updateSwitchField(record, 'isTop', checked ? 1 : 0)}
        />
      )
    },
    {
      title: '是否删除',
      dataIndex: 'isValid',
      width: 100,
      render: value =>
        value === 0 ? (
          <Tag color="red" size="small">
            已删除
          </Tag>
        ) : (
          <Tag color="green" size="small">
            未删除
          </Tag>
        )
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 120,
      fixed: 'right',
      render: (_, record) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)} loading={loading} disabled={record?.isValid === 0}>
            编辑
          </Button>
          <Popconfirm title="提示" content="是否确认删除?" onOk={() => del(record)} disabled={record?.isValid === 0}>
            <Button className="btn" type="text" status="danger" loading={loading} disabled={record?.isValid === 0}>
              删除
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);

  return (
    <div className="member-content table-flex">
      <Space style={{ flexWrap: 'wrap', marginBottom: 12 }}>
        <Form autoComplete="off" layout="inline" form={formSearch} style={{ width: '100%' }}>
          <FormItem label="内容制作日期" field="productionTimeRange">
            <RangePicker style={{ width: 260 }} placeholder={['开始日期', '结束日期']} />
          </FormItem>
          <FormItem label="标题" field="title">
            <Input style={{ width: 200 }} placeholder="请输入..." allowClear />
          </FormItem>
          <FormItem label="是否上架" field="isOnShelfFilter">
            <Select style={{ width: 120 }} placeholder="请选择" allowClear>
              {triStateYesNoOptions.map(item => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="会员专属" field="isMemberContentFilter">
            <Select style={{ width: 120 }} placeholder="请选择" allowClear>
              {triStateYesNoOptions.map(item => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="是否置顶" field="isTopFilter">
            <Select style={{ width: 120 }} placeholder="请选择" allowClear>
              {triStateYesNoOptions.map(item => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="是否删除" field="deleteStatus">
            <Select style={{ width: 120 }} placeholder="请选择" allowClear>
              {triStateYesNoOptions.map(item => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="排序" field="sortType">
            <Select style={{ width: 140 }} placeholder="请选择" allowClear>
              {sortTypeOptions.map(item => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={() => getList(true)} loading={loading}>
              查询
            </Button>
          </FormItem>
          <FormItem>
            <Button onClick={resetSearch} loading={loading}>
              重置
            </Button>
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={add} loading={loading}>
              上传内容
            </Button>
          </FormItem>
        </Form>
      </Space>

      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          loading={loading}
          scroll={{ y: '100%', x: 1960 }}
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            current: pageNum,
            showTotal: true,
            sizeOptions: [20, 50, 100],
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
        />
      </div>

      <Modal
        title={formRef.current.id ? '编辑内容' : '上传内容'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 820 }}
        confirmLoading={loading}
        maskClosable={!videoUploading}
        closable={!videoUploading}
        okButtonProps={{ disabled: videoUploading }}
        cancelButtonProps={{ disabled: videoUploading }}
      >
        <Form {...formItemLayout} form={form}>
          <FormItem label="标题" field="title" rules={[{ required: true, message: '请输入标题' }]}>
            <Input placeholder="请输入..." maxLength={50} />
          </FormItem>
          <FormItem
            label="主讲人"
            field="teacher"
            rules={[{ required: true, message: '请输入主讲人' }]}
          >
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem
            label="内容类型"
            field="contentType"
            rules={[{ required: true, message: '请选择内容类型' }]}
          >
            <Select placeholder="请选择" style={{ width: '100%' }}>
              {contentTypeOptions.map(item => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="封面上传" required>
            <FormItem field="coverUrl" noStyle rules={[{ required: true, message: '请上传封面' }]}>
              <Input style={{ display: 'none' }} />
            </FormItem>
            <Upload
              listType="picture-card"
              imagePreview
              limit={1}
              accept="image/*"
              action={URL_UPLOAD}
              data={UPLOAD_DATA}
              headers={{ Authorization: `${localStorage.getItem('authToken')}` }}
              fileList={coverFileList}
              onChange={handleCoverChange}
            />
          </FormItem>
          <FormItem label="视频上传" required>
            <FormItem field="videoUrl" noStyle rules={[{ required: true, message: '请上传视频' }]}>
              <Input style={{ display: 'none' }} />
            </FormItem>
            <Upload
              listType="picture-card"
              limit={1}
              accept="video/*"
              action={URL_UPLOAD}
              data={VIDEO_UPLOAD_DATA}
              headers={{ Authorization: `${localStorage.getItem('authToken')}` }}
              fileList={videoFileList}
              onChange={handleVideoChange}
              imagePreview={false}
              showUploadList={{
                imageRender: file => {
                  const url = getUploadItemPreviewUrl(file);
                  if (!url) return null;
                  return (
                    <video
                      src={url}
                      muted
                      playsInline
                      preload="metadata"
                      className="member-content-upload-video-thumb"
                    />
                  );
                }
              }}
              onPreview={file => {
                const url = getUploadItemPreviewUrl(file);
                if (url) {
                  setVideoPreviewUrl(url);
                  setVideoPreviewVisible(true);
                }
              }}
            />
            <div style={{ marginTop: 8, color: 'grey', fontSize: 12 }}>
              <span style={{ color: 'red' }}>*</span> 最大不超过2G，上传耗时1-2分钟，中途请勿关闭上传窗口
            </div>
          </FormItem>
          <FormItem label="思维导读" required>
            <FormItem field="mindMapUrl" noStyle rules={[{ required: true, message: '请上传思维导读' }]}>
              <Input style={{ display: 'none' }} />
            </FormItem>
            <Upload
              listType="picture-card"
              imagePreview
              limit={1}
              accept="image/*"
              action={URL_UPLOAD}
              data={UPLOAD_DATA}
              headers={{ Authorization: `${localStorage.getItem('authToken')}` }}
              fileList={mindMapFileList}
              onChange={handleMindMapChange}
            />
          </FormItem>
          {/* <FormItem label="AI解读" required>
            <FormItem field="aiInterpretationUrl" noStyle rules={[{ required: true, message: '请上传AI解读' }]}>
              <Input style={{ display: 'none' }} />
            </FormItem>
            <Upload
              listType="picture-card"
              imagePreview
              limit={1}
              accept="image/*"
              action={URL_UPLOAD}
              data={UPLOAD_DATA}
              headers={{ Authorization: `${localStorage.getItem('authToken')}` }}
              fileList={aiInterpretationFileList}
              onChange={handleAiInterpretationChange}
            />
          </FormItem> */}
          <FormItem label="简介" field="contentDesc">
            <Input.TextArea placeholder="请输入..." maxLength={1000} autoSize={{ minRows: 3, maxRows: 6 }} />
          </FormItem>
          <FormItem label="内容制作时间" field="productionTime">
            <DatePicker
              placeholder="请选择内容制作时间"
              style={{ width: '100%' }}
              showTime
              format="YYYY-MM-DD HH:mm:ss"
            />
          </FormItem>
          <FormItem label="是否置顶" field="isTop" triggerPropName="checked">
            <Switch />
          </FormItem>
          {/* <FormItem label="是否上架" field="isOnShelf" triggerPropName="checked">
            <Switch />
          </FormItem> */}
          <FormItem label="会员专属" field="isMemberContent" triggerPropName="checked" initialValue={true}>
            <Switch />
          </FormItem>
        </Form>
      </Modal>

      <Modal
        title="视频预览"
        visible={videoPreviewVisible}
        footer={null}
        onCancel={() => {
          setVideoPreviewVisible(false);
          setVideoPreviewUrl('');
        }}
        style={{ width: 720 }}
        unmountOnExit
      >
        {videoPreviewUrl ? (
          <video
            src={videoPreviewUrl}
            controls
            playsInline
            style={{ width: '100%', maxHeight: '70vh', verticalAlign: 'middle' }}
          />
        ) : null}
      </Modal>
    </div>
  );
}

export default MemberContentManagement;
